"use strict";

import { http } from '../../core';
import config from '../../app.config'
const RequestbaseURL = http.create({baseURL:config.BASEURL});

export default {
    // 服务器详情
    host_describe: function (id) {
        return RequestbaseURL.get('cmdb/v1/host/describe', { host_id: id })
    }
}
